<template>
  <div>
    <!-- <progress class="progress is-link" value="75" max="100">75%</progress> -->
    <div class="box">
      <h1 class="page-header">
        Finalize Request
      </h1>
      <div class="columns is-multiline">
        <div class="column is-half">

          <div class="field">
            <label class="label">Your Name</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Your Name" :class="{'is-required': missingName}" v-model="Request.RequesterName">
            </div>
          </div>

          <div class="field">
            <label class="label">Your Email Address</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Your Email Address" :class="{'is-required': missingEmail}" v-model="Request.RequesterEmail">
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="field">
            <label class="label">Association Name</label>
            <div class="control">
              <input disabled class="input" type="text" v-model="Request.Association.Name">
            </div>
          </div>

          <div style="padding-top: 20px;" class="has-text-centered">
            <i v-if="!missingName && !missingEmail" class="fa fa-check fa-4x"></i>
            <p v-if="!missingName && !missingEmail">Click Finalize to complete your request.</p>
            <p v-if="missingName || missingEmail">Please complete name and email address.</p>
            <br>
          </div>

          <div v-if="submitted" style="padding-top: 50px;" class="has-text-centered opaque ">
            <i class="fa fa-refresh fa-spin fa-4x "></i>
            <p>Finalizing Request...</p>
          </div>
        </div>
        <div class="column is-half">
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-text" @click="cancel">Cancel</button>
            </div>
            <div class="control">
              <button @click="previous()" class="button is-link is-outlined">Previous</button>
            </div>
            <div class="control">
              <button @click="next()" class="button is-link">Finalize</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FinalizeRequest',
    props: ['Request'],
    data: function () {
      return {
        submitted: false,
        missingName: false,
        missingEmail: false,
        found: false
      }
    },
    methods: {
      next() {
        if (!this.Request.RequesterEmail || !this.Request.RequesterName) {
          if (!this.Request.RequesterEmail) {
            this.missingEmail = true
          } else {
            this.missingEmail = false
          }

          if (!this.Request.RequesterName) {
            this.missingName = true
          } else {
            this.missingName = false
          }
        } else {
          this.submitted = true
          this.found = false
          this.$emit('finalize')
        }
      },
      previous() {
        this.$emit('previous')
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/request/FinalizeRequest.vue?6319f428